var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ae7ac0156ac2dd1a7ec37be637dfaa7cbb986fc1"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["breeze@otovo"]={id:"ae7ac0156ac2dd1a7ec37be637dfaa7cbb986fc1"};
      